import { FC } from 'react';
import GeneralSettings from './GeneralSettings';
import RoutingSettings from './RoutingSettings';
import WorkflowSettings from './WorkflowSettings';
import AppearanceSettings from './AppearanceSettings';
import LayoutSettings from './LayoutSettings';
import TimersAndAlertsSettings from './TimersAndAlertsSettings';

export interface SettingsSection {
  id: string;
  labelKey: string;
  Component: FC;
}

export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    id: 'general',
    labelKey: 'kitchenDisplay.sectionGeneral',
    Component: GeneralSettings,
  },
  {
    id: 'routing',
    labelKey: 'kitchenDisplay.sectionRouting',
    Component: RoutingSettings,
  },
  {
    id: 'workflow',
    labelKey: 'kitchenDisplay.sectionWorkflow',
    Component: WorkflowSettings,
  },
  {
    id: 'appearance',
    labelKey: 'kitchenDisplay.sectionAppearance',
    Component: AppearanceSettings,
  },
  {
    id: 'layout',
    labelKey: 'kitchenDisplay.sectionLayout',
    Component: LayoutSettings,
  },
  {
    id: 'timersAndAlerts',
    labelKey: 'kitchenDisplay.sectionTimersAndAlerts',
    Component: TimersAndAlertsSettings,
  },
];
